import { ref, onMounted } from "vue"
import { useGlobalStore } from '@/stores/GlobalStore'

const style = {
	base: {
		color: "#111928",
		fontFamily: "Arial, sans-serif",
		fontSmoothing: "antialiased",
		fontSize: "16px",
		"::placeholder": {
			color: "#9CA3AF",
		},
	},
	invalid: {
		fontFamily: "Arial, sans-serif",
		color: "#E02424",
		iconColor: "#E02424",
	},
}

export const useStripe = () => {
  const globalStore = useGlobalStore()

  const stripe = ref(null)
  const elements = ref(null)

  const initializeStripe = async (cardElement) => {
    // Set your publishable key
    stripe.value = Stripe(import.meta.env.VITE_STRIPE_TOKEN)

    globalStore.stripe = stripe.value
    
    // Create an instance of Elements
    elements.value = stripe.value.elements()

    // Create a Card Element and mount it to the DOM
    globalStore.card = elements.value.create('card', { style: style })
    globalStore.card.mount(cardElement)
  }

  const initializeStripeSplit = async ({ cardNumberEl, cardExpiryEl, cardCvcEl }) => {
    stripe.value = Stripe(import.meta.env.VITE_STRIPE_TOKEN)
    globalStore.stripe = stripe.value

    elements.value = stripe.value.elements()

    const cardNumber = elements.value.create('cardNumber', { style, showIcon: true })
    const cardExpiry = elements.value.create('cardExpiry', { style })
    const cardCvc = elements.value.create('cardCvc', { style, showIcon: true })

    cardNumber.mount(cardNumberEl)
    cardExpiry.mount(cardExpiryEl)
    cardCvc.mount(cardCvcEl)

    // keep globalStore.card pointing to cardNumber for payment confirmation compatibility
    globalStore.card = cardNumber
  }

  return {
    initializeStripe,
    initializeStripeSplit,
    stripe
  }
}